class Controller {
  constructor($mdDialog, $injector, route, $q) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.route = route;
    this.$q = $q;
  }

  $onInit() {
    this.route = {
      ...this.route,
      name: {
        key: "name",
        value: this.route.name || "",
      },
      nameAr: {
        key: "nameAr",
        value: this.route.nameAr || "",
      },
      price: {
        key: "price",
        value: this.route.price || 0,
      },
      description: {
        key: "description",
        value: this.route.description || "",
      },
    };
  }

  close() {
    this.$mdDialog.cancel();
  }

  save() {
    this.$mdDialog.hide(this.route);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dialogs/routeInfoDialog/routeInfoDialog.controller.js